import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { mockCategoryData, mockDepartmentData, mockTrendData } from '../data/mockData';
export function TrendAnalytics() {
  const sortedCategories = [...mockCategoryData].sort((a, b) => b.count - a.count).slice(0, 5);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-273">
      <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-274">
        Trend Analytics & Recurring Issues
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-275">
        {/* Issue Categories */}
        <div className="col-span-1" data-id="element-276">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-277">
            Top Issue Categories
          </h3>
          <div className="h-64" data-id="element-278">
            <ResponsiveContainer width="100%" height="100%" data-id="element-279">
              <BarChart data={sortedCategories} layout="vertical" margin={{
              top: 0,
              right: 20,
              left: 0,
              bottom: 0
            }} data-id="element-280">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f3f4f6" data-id="element-281" />
                <XAxis type="number" hide data-id="element-282" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} width={100} data-id="element-283" />
                <Tooltip cursor={{
                fill: '#f9fafb'
              }} data-id="element-284" />
                <Bar dataKey="count" fill="#6366f1" radius={[0, 4, 4, 0]} barSize={24} data-id="element-285">
                  {sortedCategories.map((entry, index) => <Cell key={`cell-${index}`} fill={index === 0 ? '#4f46e5' : '#818cf8'} data-id="element-286" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Department Volume */}
        <div className="col-span-1" data-id="element-287">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-288">
            Volume by Department
          </h3>
          <div className="h-64" data-id="element-289">
            <ResponsiveContainer width="100%" height="100%" data-id="element-290">
              <BarChart data={mockDepartmentData} margin={{
              top: 0,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-291">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-292" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} angle={-45} textAnchor="end" height={60} data-id="element-293" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-294" />
                <Tooltip cursor={{
                fill: '#f9fafb'
              }} data-id="element-295" />
                <Bar dataKey="tickets" fill="#0ea5e9" radius={[4, 4, 0, 0]} barSize={32} data-id="element-296" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Ticket Trend */}
        <div className="col-span-1" data-id="element-297">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-298">
            Ticket Volume (7 Days)
          </h3>
          <div className="h-64" data-id="element-299">
            <ResponsiveContainer width="100%" height="100%" data-id="element-300">
              <LineChart data={mockTrendData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-301">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-302" />
                <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-303" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-304" />
                <Tooltip data-id="element-305" />
                <Line type="monotone" dataKey="tickets" stroke="#10b981" strokeWidth={3} dot={{
                r: 4,
                fill: '#10b981',
                strokeWidth: 2,
                stroke: '#fff'
              }} activeDot={{
                r: 6
              }} data-id="element-306" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-6" data-id="element-307">
        <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-308">
          Recurring Issues Action Plan
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-309">
          <div className="bg-indigo-50 rounded-lg p-4 border border-indigo-100" data-id="element-310">
            <div className="flex items-center justify-between mb-2" data-id="element-311">
              <span className="font-semibold text-indigo-900" data-id="element-312">
                System Access (Encompass)
              </span>
              <span className="bg-indigo-200 text-indigo-800 text-xs font-bold px-2 py-1 rounded" data-id="element-313">
                52 Tickets
              </span>
            </div>
            <p className="text-sm text-indigo-700 mb-3" data-id="element-314">
              High volume of password resets and access requests.
            </p>
            <button className="text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 px-3 py-1.5 rounded transition-colors" data-id="element-315">
              Create Knowledge Base Article
            </button>
          </div>
          <div className="bg-orange-50 rounded-lg p-4 border border-orange-100" data-id="element-316">
            <div className="flex items-center justify-between mb-2" data-id="element-317">
              <span className="font-semibold text-orange-900" data-id="element-318">
                Salesforce Dashboard Errors
              </span>
              <span className="bg-orange-200 text-orange-800 text-xs font-bold px-2 py-1 rounded" data-id="element-319">
                48 Tickets
              </span>
            </div>
            <p className="text-sm text-orange-700 mb-3" data-id="element-320">
              Processors reporting timeout errors during peak hours.
            </p>
            <button className="text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 px-3 py-1.5 rounded transition-colors" data-id="element-321">
              Escalate to Salesforce Vendor
            </button>
          </div>
        </div>
      </div>
    </div>;
}